
import { Options, Vue } from "vue-class-component";

import {
  ChessboardExt,
  TargetManager,
  TargetManagerTypes,
  getLocal,
  setLocal,
  Svg,
} from "../dist/index.js";

class MyTargetManagerFunctionality
  implements TargetManagerTypes.CanManageTargets
{
  // mock implementation of storeState
  storeState(tms: TargetManagerTypes.TargetManagerState) {
    setLocal("targetmanager", tms);
  }
  // mock implementation of getState
  getState(def: TargetManagerTypes.TargetManagerState) {
    return Promise.resolve(getLocal("targetmanager", undefined) || def);
  }
  // mock implementation of save
  save(target: string) {
    window.alert(`My Saved ${target}!`);
  }
  // mock implementation of load
  load(target: string) {
    window.alert(`My Loaded ${target}!`);
  }
  // mock implementation of delete
  delete(target: string) {
    window.alert(`My Deleted ${target}!`);
  }
}

const MyTargetManager = TargetManagerTypes.EquipWithTargetManagerBase(
  MyTargetManagerFunctionality
);

@Options({
  components: {
    ChessboardExt,
    TargetManager,
    Svg,
  },
  methods: {
    event(ev: any) {
      console.log(ev);
    },
  },
  data() {
    return {
      welcome: document.location.href.match("showwelcome"),
      test: document.location.href.match("test"),
      targetmanager: new MyTargetManager(),
    };
  },
  mounted() {
    setTimeout(() => {
      this.$refs.cont.style.opacity = "1";
    }, 0);
  },
})

// export app
export default class App extends Vue {}
